<ng-container *ngIf="schema && show">
    <div *ngIf="schema.editorType === 'Froala' || schema.editorType === 'ToastUI'" class="main-editor" [id]="editorId"
        [ngStyle]="{'minHeight': schema.minHeight, 'maxWidth': schema.maxWidth}">
        <div [innerHtml]="schema.value"></div>
    </div>
    <textarea *ngIf="schema.editorType === 'TinyMCE'" class="main-editor" [id]="editorId"
        [ngStyle]="{'minHeight': schema.minHeight, 'maxWidth': schema.maxWidth}">{{schema.value}}</textarea>
    <div>
        <ckeditor [ngStyle]="{'minHeight': schema.minHeight, 'maxWidth': schema.maxWidth , 'height' : '20rem'}"
            class="main-editor" *ngIf="schema.editorType === 'ckEditor'" [data]="initialValue" [editor]="Editor"
            [config]="config" [id]="editorId" (change)="onEditorChange($event)"></ckeditor>
    </div>
</ng-container>